<div class="modal-header">
  <h5 class="modal-title">
    <span *ngIf="!readOnly">New </span>SMS
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  
  <div *ngIf="!readOnly && !optedIn" class="alert alert-danger d-flex align-items-center">
    <fa-icon [icon]="faExclamationCircle" size="lg" class="me-2"></fa-icon>
    Client has not opted in to text messages
  </div>

  <form [formGroup]="smsDetails" autocomplete="off">

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Phone Number:</label>
      <div class="col-sm-8">
        <input type="text" 
               class="form-control" 
               formControlName="phoneNumber">
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Message</label>
      <textarea class="form-control" 
                #message
                formControlName="message" 
                maxlength="140"
                rows="4"></textarea>
      <div class="form-text text-end" *ngIf="!readOnly">
        {{message.value?.length || 0}}/140
      </div>
    </div>

  </form>

  <div *ngIf="readOnly">
    <div class="mb-2">
      <strong>Created:</strong> {{smsObj.queuedDate | date:'dd/MM/yyyy HH:mm'}}
    </div>
    <div class="mb-2">
      <strong>Sent:</strong> {{smsObj.sentDate | date:'dd/MM/yyyy HH:mm'}}
    </div>
  </div>

</div>

<div class="modal-footer" *ngIf="!readOnly">
  <button type="button" 
          class="btn btn-success" 
          (click)="sendSMS()" 
          [disabled]="sendingSMS || smsDetails.invalid">
    <span *ngIf="sendingSMS" class="spinner-border spinner-border-sm me-2"></span>
    Send
  </button>
</div>